import { utils } from "ethers";
import moment from "moment";
import Link from "next/link";
import { getCdnUrl } from "../../../lib/getCdnUrl";
import Icon from "../../Icon";
import { helperConstants as constants } from "../../../helpers/helperConstants";

type FilledGlobalLendOfferType = {
  id: string;
  lendOfferId: string;
  nftAddress: string;
  colleteralTokenID: string;
  issuer: string;
  status: number;
  signature: string;
  startTime: number;
};

export type OfferType = {
  id: string;
  status: number;
  signature: string;
  issuer: string;
  nftAddress: string;
  colleteralTokenID: string;
  amount: string;
  filledGlobalBids: number;
  paymentToken: `0x${string}`;
  paymentTokenName: string;
  borrowAmount: string;
  interestRate: number;
  startTime: number;
  signingTime: string;
  duration: string;
  expiration: string;
  orderKind: number;
  tokenKind: number;
  isGlobal: boolean;
  createdAt: string;
  updatedAt: string;
  lendOrdersId: string;
  isExpired: boolean;
  item: any;
  collection: any;
  filledGlobalLendOffers: FilledGlobalLendOfferType[];
  lendOrders: any;
  balance: number;
  hasEnoughBalance: boolean;
  isApprovedEnough: boolean;
};

export interface AccountTableRow {
  id: string;
  eventType?: JSX.Element;
  nft: JSX.Element;
  terms: JSX.Element;
  interestRate?: JSX.Element;
  date: JSX.Element;
  expiration: JSX.Element;
  to?: JSX.Element;
  action?: JSX.Element;
  offer: OfferType;
}

export const accountRow = ({
  offer,
  action,
  eventType = false,
  interestRate = false,
  to = false,
}: {
  offer: OfferType;
  action: JSX.Element;
  eventType?: boolean;
  interestRate?: boolean;
  to?: boolean;
}): AccountTableRow => ({
  id: offer.id,
  ...(eventType && {
    eventType: (
      <Icon
        tooltip={offer.isGlobal ? "Global Offer" : "Offer"}
        display="inline-table"
        name={"icon-bids"}
        fillCurrent
      />
    ),
  }),
  nft: (
    <Link
      href={`${
        !offer.isGlobal
          ? offer?.lendOrders?.isActive &&
            !offer?.lendOrders?.isExpired &&
            offer?.lendOrders?.status === 0
            ? `/lend/${offer.nftAddress}/${offer.colleteralTokenID}`
            : `${constants.helpers.marketplace_url}/item/${offer.collection.chain}/${offer.nftAddress}/${offer.colleteralTokenID}`
          : `${constants.helpers.marketplace_url}/collection/${offer.collection.chain}/${offer.collection.pathName}`
      }`}
    >
      <a target="_blank" className="flex items-center">
        <img
          className="inline-block h-12 w-12 rounded-full "
          src={getCdnUrl(
            !offer.isGlobal
              ? offer.item.imageFtpPath
              : offer.collection.profilePhotoPath
          )}
        />
        <span className="ml-5 text-accent">
          {!offer.isGlobal
            ? offer.item.name ||
              (offer.item.metadata
                ? typeof offer.item.metadata.name === "string"
                  ? JSON.parse(offer.item.metadata).name
                  : offer.item.metadata.name
                : "")
            : offer.collection.name}
        </span>
      </a>
    </Link>
  ),
  terms: (
    <div className="flex items-center">
      <span className="text-green text-sm font-medium tracking-tight capitalize">
        {utils.formatEther(offer.borrowAmount)} {offer.paymentTokenName} /{" "}
        {moment().add(offer.duration, "seconds").fromNow(true)}
      </span>
    </div>
  ),
  ...(interestRate && {
    interestRate: (
      <div className="flex items-center">
        <span className="text-green text-sm font-medium tracking-tight capitalize">
          {Number(offer.interestRate) / 100}%
          {/* {calculateAPR(
            Number(offer.duration) / 86400,
            offer.interestRate / 100
          )}
          % */}
        </span>
      </div>
    ),
  }),
  date: (
    <div className="flex items-center">
      {moment(offer.signingTime, "X").format("DD/MM/YYYY - HH:mm").toString()}
    </div>
  ),
  expiration: (
    <div className="flex items-center">
      {moment().add(offer.expiration, "seconds").fromNow(true)}
    </div>
  ),
  ...(to && {
    to: (
      <Link
        href={`${constants?.helpers?.marketplace_url}/user/${offer.issuer}`}
      >
        <a target={"_blank"} className="text-accent">
          {offer.issuer.slice(0, 4) + "..." + offer.issuer.slice(-4)}
        </a>
      </Link>
    ),
  }),
  action,
  offer,
});
